module.exports = __webpack_public_path__ + "media/Slide12.fd2601a0.mp3";